// extracted by mini-css-extract-plugin
export var disabled = "_14-a";
export var hierarchyLinkGray = "_14-4";
export var hierarchyLinkUnderline = "_14-3";
export var hierarchyPrimary = "_14-0";
export var hierarchySecondary = "_14-1";
export var hierarchyTertiary = "_14-2";
export var pressed = "_14-6";
export var themeAction = "_14-5";
export var themeDestructive = "_14-8";
export var themeNormal = "_14-7";
export var themeSuccess = "_14-9";